import { createContext, useContext } from 'react';

/**
 * Раскрытые узлы дерева заключений: id заключений и блоков, чьё содержимое сейчас видно.
 *
 * Дерево рекурсивно, поэтому раскрытость раздаётся контекстом, а не через props: узлу любой
 * глубины нужно знать, скрыты ли его вложенные блоки, чтобы отметить правило, требующее внимания
 * внутри него.
 */
export const ExpandedTreeNodesContext = createContext<ReadonlySet<string>>(new Set());

/** Свёрнут ли узел дерева — его вложенные блоки сейчас не видны */
export const useIsNodeCollapsed = (nodeId: string): boolean => !useContext(ExpandedTreeNodesContext).has(nodeId);
